/* eslint-disable react-native/no-inline-styles */
import { useNavigation } from "@react-navigation/native";
import React, { useState } from "react";
import {
  Dimensions,
  ImageBackground,
  Modal,
  StyleSheet,
  TouchableOpacity,
  View,
} from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import LinearGradient from "react-native-linear-gradient";
import CloseIcon from "@assets/svg/CloseIcon";
import Play from "@assets/svg/Play";
import Button from "@components/Button";
import VideoPlayer from "@components/VideoPlayer";
import {
  OTHER_EVENTS,
  SHARING_EVENTS,
} from "../../constants/analyticsEventsCT";
import useGetVideoTime, {
  GetVideoTimeContextProvider,
} from "../../utils/useGetVideoTime";
import { shareOnWhatsapp } from "../../utils/shareEntity";
import useBannerCarouselContext from "./BannerCarouselContext";
import WhatsAppShare from "./WhatsAppShare";
import BannerSkeleton from "@components/CMS/Skeleton/BannerSkeleton";

const { width } = Dimensions.get("window");

const MainContainer = ({ children, imageHeight, shouldShowCTA }) => {
  const [, setState] = useBannerCarouselContext();

  const onLayout = () => {
    setState((s) => ({ ...s, height: imageHeight + (shouldShowCTA ? 60 : 0) }));
  };

  return (
    <View style={styles.relative} onLayout={onLayout}>
      {children}
    </View>
  );
};
const VideoContainer = ({ video_link = "", handleBannerPress = () => {} }) => {
  const [state] = useGetVideoTime();

  return (
    <>
      <VideoPlayer videoLink={video_link} />

      {state.isCompleted && (
        <View style={styles.isCompletedContainer}>
          <Button
            style={styles.padding}
            buttonWidth={"100%"}
            btnText={"अभी खरीदें"}
            buttonFontType="head1"
            height={56}
            borderRadius={10}
            onPress={handleBannerPress}
          />
        </View>
      )}
    </>
  );
};

const GroupBuyItem = (props) => {
  const insets = useSafeAreaInsets();
  const navigation = useNavigation();
  const {
    flatBanner = false,
    image_link = "",
    video_link = "",
    items_width,
    items_height,
    cta_text = "डीटेल्स देखे",
    share_image: sharing_image_link = "",
    share_text,
    gb_id,
    trackEvent = () => {},
  } = props;

  const [show, setShow] = useState(false);
  let bottomShadow = false;

  const [loaded, setLoaded] = useState(false);
  const [loading, setLoading] = useState(true);

  const aspectRatio = items_width / items_height;
  const widthMinusPadding = width - 40;
  const imageHeight = widthMinusPadding / aspectRatio;

  const handleShareOnWhatsapp = async () => {
    trackEvent(SHARING_EVENTS.GB_SHARE, { gb_id });
    shareOnWhatsapp({ message: share_text, image: sharing_image_link });
  };

  const shouldShowCTA = true;

  const handleBannerPress = async () => {
    setShow(false);

    navigation &&
      navigation.navigate("GroupBuyDetails", {
        groupBuyOfferId: gb_id,
        message: share_text,
        image: sharing_image_link,
      });

    if (typeof trackEvent === "function") {
      trackEvent(OTHER_EVENTS.BANNER_CLICKED, {
        cms_item_id: props.cms_item_id,
        sub_type: "GroupBuy Banner",
        cms_title: props.title_ref,
      });
    }
  };

  const _toggleModal = () => {
    setShow(!show);
  };

  const imgSource = image_link;

  const MainContainerComponent = MainContainer;

  return (
    <MainContainerComponent
      imageHeight={imageHeight}
      shouldShowCTA={shouldShowCTA}
    >
      <TouchableOpacity onPress={handleBannerPress}>
        <>
          <View
            style={[
              styles.bannerCarouselWrapper,
              {
                height: flatBanner ? imageHeight * 1.1 : imageHeight,
              },
            ]}
          >
            {loading && !loaded && (
              <BannerSkeleton inner={true} height={imageHeight} />
            )}
            <ImageBackground
              source={{
                uri: imgSource,
              }}
              imageStyle={styles.bannerBorder}
              style={[
                styles.imageBackground,
                {
                  height: !loaded ? 0 : imageHeight,
                },
              ]}
              onLoadEnd={() => {
                setLoading(false);
                setLoaded(true);
              }}
            >
              <View style={[styles.bannerCarousel, { height: imageHeight }]}>
                {bottomShadow && !flatBanner && !video_link && (
                  <LinearGradient
                    colors={[
                      "rgba(0,0,0,0.00)",
                      "rgba(0,0,0,0.03)",
                      "rgba(0,0,0,0.80)",
                    ]}
                    style={styles.linearGradientStyles}
                  />
                )}

                {Boolean(video_link) && (
                  <View style={styles.playButtonContainer}>
                    <TouchableOpacity
                      onPress={() => setShow(!show)}
                      style={styles.playButton}
                    >
                      <Play />
                    </TouchableOpacity>
                  </View>
                )}
              </View>
            </ImageBackground>
          </View>
          <Modal
            visible={show}
            transparent
            statusBarTranslucent
            navigationBarTranslucent
          >
            <View
              style={[
                styles.videoModal,
                { paddingTop: insets.top, paddingBottom: insets.bottom },
              ]}
            >
              <TouchableOpacity
                onPress={_toggleModal}
                style={[
                  styles.videoModalClose,
                  { top: insets.top + 20 },
                ]}
              >
                <CloseIcon fill={"#fff"} />
              </TouchableOpacity>
              <GetVideoTimeContextProvider>
                <VideoContainer {...{ video_link, handleBannerPress }} />
              </GetVideoTimeContextProvider>
            </View>
          </Modal>
        </>
      </TouchableOpacity>
      <View style={{ height: imageHeight / 4 }} />
      <View
        style={[
          styles.buttonRow,
          {
            top: imageHeight + 10,
          },
        ]}
      >
        <WhatsAppShare
          title={"शेयर करें"}
          semiBold={true}
          onShare={handleShareOnWhatsapp}
          wrapperStyles={styles.waShareWrapper}
        />
        <Button
          buttonWidth={150}
          btnText={cta_text}
          buttonFontType="head1"
          height={40}
          borderRadius={60}
          onPress={handleBannerPress}
        />
      </View>
    </MainContainerComponent>
  );
};

const styles = StyleSheet.create({
  bannerCarouselWrapper: {
    width: width,
    marginVertical: 4,
    paddingHorizontal: 15,
  },
  imageBackground: {
    flex: 1,
    width: "100%",
    justifyContent: "center",
    alignItems: "center",
    opacity: 1,
    display: "flex",
    borderRadius: 10,
  },
  bannerCarousel: {
    width: "100%",
    borderRadius: 10,
    justifyContent: "flex-end",
  },
  shareBtnContainer: {
    flexDirection: "row",
    justifyContent: "space-evenly",
    paddingBottom: 30,
    position: "absolute",
    width: "100%",
  },
  waShareWrapper: {
    height: 40,
    width: 150,
  },
  padding: {
    padding: 15,
  },
  buttonRow: {
    position: "absolute",
    flexDirection: "row",
    left: 0,
    right: 0,
    justifyContent: "space-around",
  },
  videoModal: {
    position: "absolute",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    backgroundColor: "#000000",
    justifyContent: "center",
  },
  videoModalClose: {
    position: "absolute",
    right: 23,
  },
  playButton: {
    height: 50,
    width: 50,
    backgroundColor: "#fff",
    elevation: 6,
    borderRadius: 50 / 2,
    alignItems: "center",
    justifyContent: "center",
    paddingLeft: 5,
  },
  playButtonContainer: {
    ...StyleSheet.absoluteFill,
    backgroundColor: "rgba(0, 0, 0, .5)",
    overflow: "hidden",
    borderRadius: 10,
    alignItems: "center",
    justifyContent: "center",
  },
  linearGradientStyles: { height: 80, borderRadius: 10 },
  relative: {
    position: "relative",
  },
  isCompletedContainer: {
    position: "absolute",
    bottom: 20,
    left: 20,
    right: 20,
  },
  bannerBorder: {
    borderRadius: 10,
  },
});

export default GroupBuyItem;
